import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useState } from 'react';
import { injectIntl } from 'react-intl-next';
import Tooltip from '@atlaskit/tooltip';
import Button from '@atlaskit/button/custom-theme-button';
import CopyIcon from '@atlaskit/icon/core/migration/copy';
import { copyTextToClipboard } from '../../../utils/clipboard';
import { codeBlockButtonMessages } from '@atlaskit/editor-common/messages';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '../../../../analytics/enums';
import AnalyticsContext from '../../../../analytics/analyticsContext';
var CopyButton = function CopyButton(_ref) {
  var content = _ref.content,
    intl = _ref.intl;
  var _useState = useState(intl.formatMessage(codeBlockButtonMessages.copyCodeToClipboard)),
    _useState2 = _slicedToArray(_useState, 2),
    tooltip = _useState2[0],
    setTooltip = _useState2[1];
  var _useState3 = useState('copy-to-clipboard'),
    _useState4 = _slicedToArray(_useState3, 2),
    className = _useState4[0],
    setClassName = _useState4[1];
  var onMouseLeave = function onMouseLeave() {
    setTooltip(intl.formatMessage(codeBlockButtonMessages.copyCodeToClipboard));
    setClassName('copy-to-clipboard');
  };
  return jsx(AnalyticsContext.Consumer, null, function (_ref2) {
    var fireAnalyticsEvent = _ref2.fireAnalyticsEvent;
    return jsx("span", null, jsx(Tooltip, {
      content: tooltip,
      hideTooltipOnClick: false,
      position: "top"
    }, jsx("div", {
      onMouseLeave: onMouseLeave
    }, jsx(Button, {
      appearance: "subtle",
      "aria-haspopup": true,
      "aria-label": tooltip
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      ,
      className: className,
      iconBefore: jsx(CopyIcon, {
        label: tooltip
      }),
      onClick: function onClick(event) {
        fireAnalyticsEvent({
          // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.EDITOR_TTI | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
          // This error was introduced after upgrading to TypeScript 5
          action: ACTION.CLICKED,
          actionSubject: ACTION_SUBJECT.BUTTON,
          actionSubjectId: ACTION_SUBJECT_ID.CODEBLOCK_COPY,
          eventType: EVENT_TYPE.UI
        });
        copyTextToClipboard(content);
        setTooltip(intl.formatMessage(codeBlockButtonMessages.copiedCodeToClipboard));
        setClassName('copy-to-clipboard clicked');
        event.stopPropagation();
      },
      spacing: "compact"
    }))));
  });
};
export default injectIntl(CopyButton);